// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`TextInput test Match con el snapshot 1`] = `
<div class="container float-container"><label for="text-1" class=""></label> <input id="text-1" name="text-1" type="search" placeholder="" class="">
    <!---->
    <!---->
</div>
`;
